var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import ModalBase from "@irati/ui/src/Modal";
import { H2 } from "@irati/ui/src/Headings";
import { Card } from "@irati/ui/src/Layout";
import FormattedMessage from "@irati/utils/lang";
import Header from "./Header";
var IMAGE_SIZE = 140;
var Modal = styled(ModalBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: ", "px;\n  .modal-content {\n    max-width: 450px;\n    margin: auto;\n  }\n  ", " {\n    padding: 0;\n  }\n"], ["\n  padding-top: ", "px;\n  .modal-content {\n    max-width: 450px;\n    margin: auto;\n  }\n  ", " {\n    padding: 0;\n  }\n"])), IMAGE_SIZE / 2, ModalBase.Inner);
var MFAModal = function (_a) {
    var children = _a.children, header = _a.header, props = __rest(_a, ["children", "header"]);
    return (React.createElement(Modal, __assign({}, props),
        React.createElement(Header, { size: IMAGE_SIZE }),
        React.createElement(H2, { className: "center" },
            React.createElement(FormattedMessage, { id: header })),
        React.createElement(Card, { noBorder: true }, children)));
};
export default MFAModal;
var templateObject_1;
